import LoadingManager from './LoadingManager'
export default LoadingManager
